import React from 'react';
import Calendar from '../../../../lib/Calendar/Calendar';

interface IDateInputProps {
  value?: string;
  onChange?: (e: any) => void;
}

const DateInput: React.FC<React.PropsWithChildren<React.PropsWithChildren<IDateInputProps>>> = ({ value = '', onChange }) => {
  function handleSelect(e) {
    onChange?.({ target: { name: 'date', value: e } });
  }
  return (
    <div className="max-w-md mx-auto md:mt-8">
      <Calendar
        selectedDates={[value]}
        date={(value && value) || undefined}
        onDateSelect={handleSelect}
      />
    </div>
  );
};
export default DateInput;
